import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const data = [
	{ name: 'Group A', value: 400, color: '#A9C46C' },
	{ name: 'Group B', value: 300, color: '#213555' },
	{ name: 'Group C', value: 300, color: '#eab308' },
	{ name: 'Group D', value: 200, color: '#ef4444' },
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill='white'
			fontSize={14}
			fontWeight='bold'
			textAnchor={x > cx ? 'start' : 'end'}
			dominantBaseline='central'>
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

export default class PieChartComponent extends PureComponent {
	render() {
		return (
			<div className='w-full md:w-1/2 h-[450px] shadow-md rounded-lg p-4 mt-6 bg-[#F3FDE8] flex flex-col items-center'>
				<div className='w-64 h-64'>
					<ResponsiveContainer width='100%' height='100%'>
						<PieChart>
							<Pie
								data={data}
								cx='50%'
								cy='50%'
								labelLine={false}
								label={renderCustomizedLabel}
								outerRadius={100}
								dataKey='value'>
								{data.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={entry.color} />
								))}
							</Pie>
						</PieChart>
					</ResponsiveContainer>
				</div>

				{/* Color Legend */}
				<div className='flex flex-wrap mt-4 gap-4'>
					{data.map((entry, index) => (
						<div key={index} className='flex items-center'>
							<span
								className='w-4 h-4 rounded-full inline-block mr-2'
								style={{ backgroundColor: entry.color }}></span>
							<span className='text-sm font-medium text-gray-700'>{entry.name}</span>
						</div>
					))}
				</div>
			</div>
		);
	}
}
